'use strict';
/*
 * This checks to see if two inputs match eachother. If they don't, it marks the field as invalid.
 */

angular.module('msUtility').directive('msMatch', [function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      msMatch: '='
    },
    link: function link(scope, elm, attrs, ctrl) {
      scope.$watchCollection('[ngModel, msMatch]', function (newValues) {
        var value = newValues[0];
        var match = newValues[1];
        // check to see if match has been set - if not don't bother displaying validity
        if (!match) {
          ctrl.$setPristine();
        } else if (value) {
          ctrl.$dirty = true;
        }
        ctrl.$setValidity('match', value === match);
      });
    }
  };
}]);